import * as amplitude from "@amplitude/analytics-browser";
import { logStatsigEvent } from "../../services/googleTagManager";

// Net-new events for the web41 demand test (design doc "Measurements"). Each
// goes to Amplitude (analysis) and Statsig (metrics / guardrail readout).
export const RESERVATION_EVENTS = {
  entryClicked: "reservation_entry_clicked", // { position: "hero" | "bottom" }
  dateSelected: "reservation_date_selected", // { preset, offset_days }
  reserveClicked: "reservation_reserve_clicked", // { preset, offset_days, start_date }
  comingSoonViewed: "reservation_coming_soon_viewed",
  trialFromComingSoon: "reservation_trial_started_from_coming_soon",
} as const;

export function trackReservation(
  name: (typeof RESERVATION_EVENTS)[keyof typeof RESERVATION_EVENTS],
  props?: Record<string, string | number | boolean | undefined>
): void {
  amplitude.track(name, props);
  logStatsigEvent(name, undefined, props);
}
